"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _AttributeVisualizationEngine_uuidGenerator, _AttributeVisualizationEngine_viewport, _AttributeVisualizationEngine_attributes, _AttributeVisualizationEngine_defaultMaterial, _AttributeVisualizationEngine_defaultLayer, _AttributeVisualizationEngine_layers, _AttributeVisualizationEngine_overview, _AttributeVisualizationEngine_listeners, _AttributeVisualizationEngine_visualizedMaterialType, _AttributeVisualizationEngine_layerMaterialType, _AttributeVisualizationEngine_nodesWithAttributeData;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributeVisualizationEngine = void 0;
/* eslint-disable no-case-declarations */
const viewer_1 = require("@shapediver/viewer");
const viewer_shared_services_1 = require("@shapediver/viewer.shared.services");
const viewer_shared_types_1 = require("@shapediver/viewer.shared.types");
const gl_matrix_1 = require("gl-matrix");
const AttributeVisualizationUtils_1 = require("./AttributeVisualizationUtils");
class AttributeVisualizationEngine {
    // #endregion Properties (7)
    // #region Constructors (1)
    constructor(viewport) {
        // #region Properties (7)
        _AttributeVisualizationEngine_uuidGenerator.set(this, viewer_shared_services_1.UuidGenerator.instance);
        _AttributeVisualizationEngine_viewport.set(this, void 0);
        _AttributeVisualizationEngine_attributes.set(this, []);
        _AttributeVisualizationEngine_defaultMaterial.set(this, new viewer_shared_types_1.MaterialUnlitData({
            color: "#000000",
            opacity: 1,
        }));
        _AttributeVisualizationEngine_defaultLayer.set(this, {
            color: "#000000",
            opacity: 1,
            enabled: true,
        });
        _AttributeVisualizationEngine_layers.set(this, {});
        _AttributeVisualizationEngine_overview.set(this, void 0);
        _AttributeVisualizationEngine_listeners.set(this, {});
        _AttributeVisualizationEngine_visualizedMaterialType.set(this, "unlit");
        _AttributeVisualizationEngine_layerMaterialType.set(this, "unlit");
        _AttributeVisualizationEngine_nodesWithAttributeData.set(this, []);
        __classPrivateFieldSet(this, _AttributeVisualizationEngine_viewport, viewport, "f");
        __classPrivateFieldSet(this, _AttributeVisualizationEngine_overview, __classPrivateFieldGet(this, _AttributeVisualizationEngine_viewport, "f").createSDTFOverview(viewer_1.sceneTree.root), "f");
        this.createLayers();
        this.gatherNodesWithAttributeData();
        this.constructAttributeVisualization();
        const cb = () => {
            __classPrivateFieldSet(this, _AttributeVisualizationEngine_overview, __classPrivateFieldGet(this, _AttributeVisualizationEngine_viewport, "f").createSDTFOverview(viewer_1.sceneTree.root), "f");
            const layers = __classPrivateFieldGet(this, _AttributeVisualizationEngine_layers, "f");
            this.createLayers();
            for (const l in layers) {
                if (__classPrivateFieldGet(this, _AttributeVisualizationEngine_layers, "f")[l])
                    __classPrivateFieldGet(this, _AttributeVisualizationEngine_layers, "f")[l] = layers[l];
            }
            this.gatherNodesWithAttributeData();
            this.constructAttributeVisualization();
            for (const l in __classPrivateFieldGet(this, _AttributeVisualizationEngine_listeners, "f"))
                __classPrivateFieldGet(this, _AttributeVisualizationEngine_listeners, "f")[l]();
        };
        (0, viewer_1.addListener)(viewer_shared_services_1.EVENTTYPE.SESSION.SESSION_CUSTOMIZED, cb);
        (0, viewer_1.addListener)(viewer_shared_services_1.EVENTTYPE.SESSION.SESSION_SDTF_DELAYED_LOADED, cb);
    }
    // #endregion Constructors (1)
    // #region Public Accessors (3)
    gatherNodesWithAttributeData() {
        __classPrivateFieldSet(this, _AttributeVisualizationEngine_nodesWithAttributeData, [], "f");
        viewer_1.sceneTree.root.traverse((node) => {
            if (node.data.some((d) => d instanceof viewer_shared_types_1.SDTFItemData)) {
                __classPrivateFieldGet(this, _AttributeVisualizationEngine_nodesWithAttributeData, "f").push(node);
            }
        });
    }
    get defaultMaterial() {
        return __classPrivateFieldGet(this, _AttributeVisualizationEngine_defaultMaterial, "f");
    }
    get defaultLayer() {
        return __classPrivateFieldGet(this, _AttributeVisualizationEngine_defaultLayer, "f");
    }
    get layers() {
        return __classPrivateFieldGet(this, _AttributeVisualizationEngine_layers, "f");
    }
    get layerMaterialType() {
        return __classPrivateFieldGet(this, _AttributeVisualizationEngine_layerMaterialType, "f");
    }
    get visualizedMaterialType() {
        return __classPrivateFieldGet(this, _AttributeVisualizationEngine_visualizedMaterialType, "f");
    }
    get overview() {
        return __classPrivateFieldGet(this, _AttributeVisualizationEngine_overview, "f");
    }
    // #endregion Public Accessors (3)
    // #region Public Methods (3)
    updateAttributes(attributes) {
        __classPrivateFieldSet(this, _AttributeVisualizationEngine_attributes, attributes, "f");
        this.constructAttributeVisualization();
    }
    updateDefaultLayer(layer) {
        __classPrivateFieldSet(this, _AttributeVisualizationEngine_defaultLayer, layer, "f");
        this.constructAttributeVisualization();
    }
    updateDefaultMaterial(material) {
        __classPrivateFieldSet(this, _AttributeVisualizationEngine_defaultMaterial, material, "f");
        this.constructAttributeVisualization();
    }
    updateLayerMaterialType(type) {
        __classPrivateFieldSet(this, _AttributeVisualizationEngine_layerMaterialType, type, "f");
        this.createLayers();
        this.constructAttributeVisualization();
    }
    updateVisualizedMaterialType(type) {
        __classPrivateFieldSet(this, _AttributeVisualizationEngine_visualizedMaterialType, type, "f");
        this.createLayers();
        this.constructAttributeVisualization();
    }
    updateLayers(layers) {
        __classPrivateFieldSet(this, _AttributeVisualizationEngine_layers, layers, "f");
        this.constructAttributeVisualization();
    }
    addListener(cb) {
        const token = __classPrivateFieldGet(this, _AttributeVisualizationEngine_uuidGenerator, "f").create();
        __classPrivateFieldGet(this, _AttributeVisualizationEngine_listeners, "f")[token] = cb;
        return token;
    }
    removeListener(token) {
        if (!__classPrivateFieldGet(this, _AttributeVisualizationEngine_listeners, "f")[token])
            return false;
        delete __classPrivateFieldGet(this, _AttributeVisualizationEngine_listeners, "f")[token];
        return true;
    }
    // #endregion Public Methods (3)
    // #region Private Methods (2)
    constructAttributeVisualization() {
        __classPrivateFieldGet(this, _AttributeVisualizationEngine_viewport, "f").visualizeAttributes = (overview, itemData) => {
            // early out if there are not attributes in this itemData
            if (!itemData || !itemData.attributes) {
                if (__classPrivateFieldGet(this, _AttributeVisualizationEngine_attributes, "f").length === 0) {
                    // return default layer material
                    let material;
                    if (__classPrivateFieldGet(this, _AttributeVisualizationEngine_layerMaterialType, "f") === "unlit") {
                        material = new viewer_shared_types_1.MaterialUnlitData({
                            opacity: __classPrivateFieldGet(this, _AttributeVisualizationEngine_defaultLayer, "f").enabled
                                ? __classPrivateFieldGet(this, _AttributeVisualizationEngine_defaultLayer, "f").opacity
                                : 0,
                            color: __classPrivateFieldGet(this, _AttributeVisualizationEngine_defaultLayer, "f").color,
                        });
                    }
                    else {
                        material = new viewer_shared_types_1.MaterialStandardData({
                            opacity: __classPrivateFieldGet(this, _AttributeVisualizationEngine_defaultLayer, "f").enabled
                                ? __classPrivateFieldGet(this, _AttributeVisualizationEngine_defaultLayer, "f").opacity
                                : 0,
                            color: __classPrivateFieldGet(this, _AttributeVisualizationEngine_defaultLayer, "f").color,
                        });
                    }
                    return {
                        matrix: gl_matrix_1.mat4.create(),
                        material,
                    };
                }
                else {
                    // return default layer material
                    let material;
                    if (__classPrivateFieldGet(this, _AttributeVisualizationEngine_layerMaterialType, "f") === "unlit") {
                        material = new viewer_shared_types_1.MaterialUnlitData({
                            opacity: __classPrivateFieldGet(this, _AttributeVisualizationEngine_defaultLayer, "f").enabled
                                ? __classPrivateFieldGet(this, _AttributeVisualizationEngine_defaultLayer, "f").opacity *
                                    __classPrivateFieldGet(this, _AttributeVisualizationEngine_defaultMaterial, "f").opacity
                                : 0,
                            color: __classPrivateFieldGet(this, _AttributeVisualizationEngine_defaultMaterial, "f").color,
                        });
                    }
                    else {
                        material = new viewer_shared_types_1.MaterialStandardData({
                            opacity: __classPrivateFieldGet(this, _AttributeVisualizationEngine_defaultLayer, "f").enabled
                                ? __classPrivateFieldGet(this, _AttributeVisualizationEngine_defaultLayer, "f").opacity *
                                    __classPrivateFieldGet(this, _AttributeVisualizationEngine_defaultMaterial, "f").opacity
                                : 0,
                            color: __classPrivateFieldGet(this, _AttributeVisualizationEngine_defaultMaterial, "f").color,
                        });
                    }
                    return {
                        matrix: gl_matrix_1.mat4.create(),
                        material,
                    };
                }
            }
            // search for the responsible layer property, if none is found, default layer is assigned
            let layer = this.defaultLayer;
            if (itemData.attributes["layer"] &&
                viewer_shared_types_1.SdtfPrimitiveTypeGuard.isStringType(itemData.attributes["layer"].typeHint)) {
                const layerAttributes = itemData.attributes["layer"];
                layer = __classPrivateFieldGet(this, _AttributeVisualizationEngine_layers, "f")[layerAttributes.value];
            }
            // early out, layer is not enabled
            if (layer.enabled === false) {
                const mat = this.createMaterialCopy(__classPrivateFieldGet(this, _AttributeVisualizationEngine_defaultMaterial, "f"));
                mat.opacity = 0;
                return {
                    matrix: gl_matrix_1.mat4.create(),
                    material: mat,
                };
            }
            if (__classPrivateFieldGet(this, _AttributeVisualizationEngine_attributes, "f").length === 0) {
                // no attributes are specified, we go into layer visualization mode
                let material;
                if (__classPrivateFieldGet(this, _AttributeVisualizationEngine_layerMaterialType, "f") === "unlit") {
                    material = new viewer_shared_types_1.MaterialUnlitData({
                        opacity: layer.opacity,
                        color: layer.color,
                    });
                }
                else {
                    material = new viewer_shared_types_1.MaterialStandardData({
                        opacity: layer.opacity,
                        color: layer.color,
                    });
                }
                return {
                    matrix: gl_matrix_1.mat4.create(),
                    material,
                };
            }
            else {
                // attributes are specified, we go into attribute visualization mode
                const material = __classPrivateFieldGet(this, _AttributeVisualizationEngine_visualizedMaterialType, "f") === "unlit"
                    ? new viewer_shared_types_1.MaterialUnlitData()
                    : new viewer_shared_types_1.MaterialStandardData();
                for (let i = 0; i < __classPrivateFieldGet(this, _AttributeVisualizationEngine_attributes, "f").length; i++) {
                    const a = __classPrivateFieldGet(this, _AttributeVisualizationEngine_attributes, "f")[i];
                    if (itemData.attributes[a.key] &&
                        itemData.attributes[a.key].typeHint === a.type) {
                        const itemDataAttribute = itemData.attributes[a.key];
                        const itemDataAttributeOverview = overview[a.key].filter((o) => o.typeHint === a.type)[0];
                        switch (true) {
                            case viewer_shared_types_1.SdtfPrimitiveTypeGuard.isColorType(a.type):
                                // multiply each color values with 255 to convert them to the range [0, 255]
                                const convertedValue = itemDataAttribute.value.map((v) => v * 255);
                                material.color = convertedValue;
                                material.opacity *= layer.opacity;
                                return {
                                    matrix: gl_matrix_1.mat4.create(),
                                    material,
                                };
                            case viewer_shared_types_1.SdtfPrimitiveTypeGuard.isNumberType(a.type):
                                const numberAttribute = a;
                                const numberVisualizationData = AttributeVisualizationUtils_1.AttributeVisualizationUtils.numberVisualization(itemDataAttribute.value, (numberAttribute.min !== undefined
                                    ? numberAttribute.min
                                    : itemDataAttributeOverview.min), (numberAttribute.max !== undefined
                                    ? numberAttribute.max
                                    : itemDataAttributeOverview.max), numberAttribute.visualization, __classPrivateFieldGet(this, _AttributeVisualizationEngine_visualizedMaterialType, "f"), __classPrivateFieldGet(this, _AttributeVisualizationEngine_defaultMaterial, "f"));
                                if (!numberVisualizationData) {
                                    return {
                                        matrix: gl_matrix_1.mat4.create(),
                                        material,
                                    };
                                }
                                else {
                                    numberVisualizationData.material.opacity *=
                                        layer.opacity;
                                    return numberVisualizationData;
                                }
                            case viewer_shared_types_1.SdtfPrimitiveTypeGuard.isStringType(a.type):
                                const stringAttribute = a;
                                const stringVisualizationData = AttributeVisualizationUtils_1.AttributeVisualizationUtils.stringVisualization(itemDataAttribute.value, stringAttribute.values ||
                                    itemDataAttributeOverview.values, stringAttribute.visualization, __classPrivateFieldGet(this, _AttributeVisualizationEngine_visualizedMaterialType, "f"), __classPrivateFieldGet(this, _AttributeVisualizationEngine_defaultMaterial, "f"));
                                if (!stringVisualizationData) {
                                    return {
                                        matrix: gl_matrix_1.mat4.create(),
                                        material,
                                    };
                                }
                                else {
                                    stringVisualizationData.material.opacity *=
                                        layer.opacity;
                                    return stringVisualizationData;
                                }
                            default:
                                const defaultAttribute = a;
                                material.color = defaultAttribute.color;
                                material.opacity *= layer.opacity;
                                return {
                                    matrix: gl_matrix_1.mat4.create(),
                                    material,
                                };
                        }
                    }
                }
                // no attributes were found, return the default material adjusted by the layer opacity
                const mat = this.createMaterialCopy(__classPrivateFieldGet(this, _AttributeVisualizationEngine_defaultMaterial, "f"));
                mat.opacity *= layer.opacity;
                return {
                    matrix: gl_matrix_1.mat4.create(),
                    material: mat,
                };
            }
        };
        // update all nodes with attribute data
        // also update the geometry data items
        __classPrivateFieldGet(this, _AttributeVisualizationEngine_nodesWithAttributeData, "f").forEach((n) => {
            n.traverseData((d) => {
                if (d instanceof viewer_shared_types_1.GeometryData)
                    d.updateVersion();
            });
            n.updateVersion();
        });
    }
    createMaterialCopy(material) {
        if (material instanceof viewer_shared_types_1.MaterialGemData) {
            const newMaterial = new viewer_shared_types_1.MaterialGemData();
            newMaterial.copy(material);
            return newMaterial;
        }
        else if (material instanceof viewer_shared_types_1.MaterialShadowData) {
            const newMaterial = new viewer_shared_types_1.MaterialShadowData();
            newMaterial.copy(material);
            return newMaterial;
        }
        else if (material instanceof viewer_shared_types_1.MaterialSpecularGlossinessData) {
            const newMaterial = new viewer_shared_types_1.MaterialSpecularGlossinessData();
            newMaterial.copy(material);
            return newMaterial;
        }
        else if (material instanceof viewer_shared_types_1.MaterialStandardData) {
            const newMaterial = new viewer_shared_types_1.MaterialStandardData();
            newMaterial.copy(material);
            return newMaterial;
        }
        else if (material instanceof viewer_shared_types_1.MaterialUnlitData) {
            const newMaterial = new viewer_shared_types_1.MaterialUnlitData();
            newMaterial.copy(material);
            return newMaterial;
        }
        else {
            return new viewer_shared_types_1.MaterialStandardData();
        }
    }
    createLayers() {
        __classPrivateFieldSet(this, _AttributeVisualizationEngine_layers, {}, "f");
        if (__classPrivateFieldGet(this, _AttributeVisualizationEngine_overview, "f")["layer"]) {
            const layerStringAttributeOverview = __classPrivateFieldGet(this, _AttributeVisualizationEngine_overview, "f")["layer"].find((a) => a.typeHint === "string");
            if (layerStringAttributeOverview &&
                layerStringAttributeOverview.values) {
                for (let i = 0; i < layerStringAttributeOverview.values.length; i++) {
                    __classPrivateFieldGet(this, _AttributeVisualizationEngine_layers, "f")[layerStringAttributeOverview.values[i]] = {
                        enabled: true,
                        opacity: 1,
                        color: this.defaultMaterial.color,
                    };
                }
            }
        }
    }
}
exports.AttributeVisualizationEngine = AttributeVisualizationEngine;
_AttributeVisualizationEngine_uuidGenerator = new WeakMap(), _AttributeVisualizationEngine_viewport = new WeakMap(), _AttributeVisualizationEngine_attributes = new WeakMap(), _AttributeVisualizationEngine_defaultMaterial = new WeakMap(), _AttributeVisualizationEngine_defaultLayer = new WeakMap(), _AttributeVisualizationEngine_layers = new WeakMap(), _AttributeVisualizationEngine_overview = new WeakMap(), _AttributeVisualizationEngine_listeners = new WeakMap(), _AttributeVisualizationEngine_visualizedMaterialType = new WeakMap(), _AttributeVisualizationEngine_layerMaterialType = new WeakMap(), _AttributeVisualizationEngine_nodesWithAttributeData = new WeakMap();
//# sourceMappingURL=AttributeVisualizationEngine.js.map